import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Button, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { PATH_NAME } from '../../../configs/pathName';
import colorConfigs from '../../../configs/colorConfigs';
import { typo } from '../../../assets/fonts/font';
import loginPageStyles from '../../../styles/PublicPage/login';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);
    if (countdown === 0) {
      navigate(PATH_NAME.MEMBER, { replace: true });
    }
    return () => clearInterval(timer);
  }, [countdown, navigate]);

  return (
    <Container 
      style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: 'calc(100vh - 25%)',
        textAlign: 'center'
      }}
    >
      <Box>
        <CheckCircleIcon style={{ fontSize: 150, color: colorConfigs.primary, backgroundColor: colorConfigs.secondary, marginBottom: '20px' }} />
        <Typography variant="h4" gutterBottom sx={{ ...typo.headline }}>
          Payment Successful!
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ ...typo.bodyContent }}>
          Thank you for your payment.
        </Typography>
        <Button 
          variant="contained" 
          sx={{ ...typo.button, ...loginPageStyles.loginButton }}
          onClick={() => navigate(PATH_NAME.MEMBER)}
          style={{ marginTop: '20px' }}
        >
          Back to Home
        </Button>
        <Typography variant="body2" gutterBottom style={{ marginTop: '10px' }} sx={{ ...typo.bodyContent }}>
          This page will redirect in {countdown} seconds...
        </Typography>
      </Box>
    </Container>
  );
};

export default PaymentSuccessPage;